"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 18: UNROM variant with two switchable 16 KB PRG banks
 * ------------------------------------------------------------------ *
 * Similar to mapper 2 (UxROM) but the $C000 window is also switchable
 * instead of being fixed to the last bank.
 *
 * - PRG ROM: two 16 KB switchable windows at $8000 and $C000.
 * - CHR: Usually CHR-RAM (8 KB at $0000), but some boards have CHR-ROM.
 * - Mirroring: Hardwired vertical/horizontal from iNES header.
 * - No IRQ, no PRG RAM.
 * - Bankswitching: write to $8000-$FFFF selects 16 KB bank.
 *   - Bit 0-3: bank number
 *   - Bit 4:   selects which window ($8000 vs $C000) — some variants use
 *              address bit 14 ($8000 vs $C000 range), others use a bit.
 *              Here we decode by address range: $8000-$BFFF -> bank 0,
 *              $C000-$FFFF -> bank 1.
 * - CHR bank select (when CHR ROM present): bits 4-7 select 8 KB CHR bank.
 * ------------------------------------------------------------------ */

function register(Mappers) {
  Mappers[18] = function (nes) {
    this.nes = nes;
    this.currentVromBank = 0;
    this.prgBank0 = 0; // $8000-$BFFF
    this.prgBank1 = 0; // $C000-$FFFF
  };

  Mappers[18].prototype = new Mappers[0]();

  Mappers[18].prototype.irqClockRate = "none";

  Mappers[18].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);

    this.currentVromBank = 0;
    this.prgBank0 = 0;
    this.prgBank1 = 0;
    this.mirroring = this.nes.rom.mirroring;

    // Initialize CHR
    if (this.nes.rom.chrSize > 0) {
      var num8kBanks = this.nes.rom.header[5];
      if (num8kBanks && num8kBanks > 0) {
        this.currentVromBank = 0;
        this.load8kVromBank(0, 0x0000);
      } else {
        this.loadCHRROM();
      }
    }
  };

  Mappers[18].prototype.write = function (address, value) {
    if (address < 0x8000) {
      if (address >= 0x6000) {
        // WRAM if enabled
      }
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // Decode which window by address bit 14 ($8000-$BFFF vs $C000-$FFFF)
    var isHighWindow = (address & 0x4000) !== 0;

    if (isHighWindow) {
      // $C000-$FFFF: switch bank at $C000
      this.prgBank1 = value & 0x0f;
      this.loadRomBank(this.prgBank1, 0xc000);
    } else {
      // $8000-$BFFF: switch bank at $8000
      this.prgBank0 = value & 0x0f;
      this.loadRomBank(this.prgBank0, 0x8000);
    }

    // CHR ROM bank select (when present): bits 4-7 select 8 KB CHR bank
    var num8kBanks = this.nes.rom.header[5];
    if (num8kBanks && num8kBanks > 0) {
      var chr8kBank = (value >> 4) & 0x0f;
      var max8kBanks = Math.min(num8kBanks, 16);
      chr8kBank = Math.min(chr8kBank, max8kBanks - 1);
      this.load8kVromBank(chr8kBank * 2, 0x0000);
    }
  };

  Mappers[18].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("UNROM variant 18: Invalid ROM! Unable to load.");
    }

    // Power-on: bank 0 at $8000, bank 1 at $C000
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(1 % this.nes.rom.romCount, 0xc000);

    // Load CHR data
    var num8kBanks = this.nes.rom.header[5];
    if (num8kBanks && num8kBanks > 0) {
      this.currentVromBank = 0;
      this.load8kVromBank(0, 0x0000);
    } else {
      this.loadCHRROM();
    }

    this.nes.cpu.requestIrq(this.nes.cpu.IRQ_RESET);
  };

  Mappers[18].prototype.toJSON = function () {
    var s = Mappers[0].prototype.toJSON.apply(this);
    s.prgBank0 = this.prgBank0;
    s.prgBank1 = this.prgBank1;
    return s;
  };

  Mappers[18].prototype.fromJSON = function (s) {
    Mappers[0].prototype.fromJSON.apply(this, arguments);
    this.prgBank0 = s.prgBank0 || 0;
    this.prgBank1 = s.prgBank1 || 0;
    this.loadRomBank(this.prgBank0, 0x8000);
    this.loadRomBank(this.prgBank1, 0xc000);
  };
}

module.exports = { register: register };
